import React from 'react'
import './index.css'
import { Typography } from '@mui/material'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faEnvelope } from '@fortawesome/pro-light-svg-icons'

export const Footer: React.FC = () => {
  return (
    <div className="App-footer">
      <div className="footer-wrapper">
        <a
          className="address"
          href="https://www.google.com/maps/search/?api=1&query=77%20Massachusetts%20Avenue,%20Cambridge,%20MA,%20USA"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Typography
            variant="body1"
            mb={0}
            style={{
              fontWeight: 600,
              fontFamily: 'NHaasGroteskTXPro-55Rg',
              fontSize: '15px',
              lineHeight: '18.75px',
            }}
          >
            Massachusetts Institute of Technology
          </Typography>
          <Typography
            variant="body2"
            mb={0}
            style={{
              fontWeight: 400,
              fontFamily: 'NHaasGroteskTXPro-55Rg',
              fontSize: '15px',
              lineHeight: '18.75px',
            }}
          >
            77 Massachusetts Avenue, Cambridge, MA, USA
          </Typography>
        </a>
        <div className="email-wrapper">
          <a
            className="email"
            href="https://www.mit.edu/accessibility/"
            target="_blank"
            rel="noreferrer noopener"
          >
            {/* <FontAwesomeIcon icon={faEnvelope} color="black" size="1x" /> */}
            <Typography
              variant="body2"
              mb={0}
              style={{
                fontWeight: 400,
                fontFamily: 'NHaasGroteskTXPro-55Rg',
                fontSize: '15px',
                lineHeight: '18.75px',
              }}
            >
              Accessibility
            </Typography>
          </a>
          <a
            className="email"
            href="https://www.mit.edu/privacy/"
            target="_blank"
            rel="noreferrer noopener"
          >
            {/* <FontAwesomeIcon icon={faEnvelope} color="black" size="1x" /> */}
            <Typography
              variant="body2"
              mb={0}
              style={{
                fontWeight: 400,
                fontFamily: 'NHaasGroteskTXPro-55Rg',
                fontSize: '15px',
                lineHeight: '18.75px',
              }}
            >
              Privacy
            </Typography>
          </a>
          <a
            className="email"
            href="https://www.mit.edu/contact/"
            target="_blank"
            rel="noreferrer noopener"
          >
            {/* <FontAwesomeIcon icon={faEnvelope} color="black" size="1x" /> */}
            <Typography
              variant="body2"
              mb={0}
              style={{
                fontWeight: 400,
                fontFamily: 'NHaasGroteskTXPro-55Rg',
                fontSize: '15px',
                lineHeight: '18.75px',
              }}
            >
              Contact
            </Typography>
          </a>
        </div>
      </div>
    </div>
  )
}
